import { render, staticRenderFns } from "./Mountain.vue?vue&type=template&id=29445acb&scoped=true&"
import script from "./Mountain.vue?vue&type=script&lang=js&"
export * from "./Mountain.vue?vue&type=script&lang=js&"
import style0 from "./Mountain.vue?vue&type=style&index=0&id=29445acb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29445acb",
  null
  
)

export default component.exports